export const ItemTypes = {
  BLOCK: 'block',
  SECUNDARY_BLOCK: 'secundary-block',
  SPECIAL_BLOCK: 'special-block'
}
